import React, { useState, useEffect } from "react";
import Portfolio from "../Items/Portfolio";

const filters = [
  {
    id: 1,
    name: "All Projects",
  },

  {
    id: 4,
    name: "E-Commerce",
  },
  {
    id: 5,
    name: "LMS Website",
  },
  {
    id: 3,
    // name: "Hotel Management System",
    name: "HMS",
  },
  {
    id: 2,
    name: "HRMS",
  },
  {
    id: 7,
    name: "SCMS",
  },
  {
    id: 6,
    name: "Portfolio",
  },
];

const allData = [
  {
    id: 1,
    name: "Learning Management System",
    category: ["lms website"],
    image: "images/portfolio/lms-portfolio.jpg",
    slug: "Learning-Management-System",
  },

  {
    id: 2,
    name: "HR Management System",
    category: ["hrms"],
    image: "images/portfolio/HRMS-portfolio.jpg",
    slug: "apple-usb",
  },
  {
    id: 3,
    name: "Sales Commission Management System",
    category: ["scms"],
    image: "images/portfolio/SCMS-portfolio.jpg",
    slug: "scms",
  },
  {
    id: 4,
    name: "MM Client Portfolio",
    category: ["portfolio"],
    image: "images/portfolio/4.jpg",
    slug: "creative-bulb",
  },
  {
    id: 5,
    name: "Iphone 8",
    category: ["branding", "art"],
    image: "images/portfolio/5.jpg",
    slug: "iphone-8",
  },
  {
    id: 6,
    name: "Minimal Art",
    category: ["design", "creative"],
    image: "images/portfolio/6.jpg",
    slug: "minimal-art",
  },
  {
    id: 7,
    name: "Creative Art",
    category: ["creative"],
    image: "images/portfolio/1.jpg",
    slug: "creative-art",
  },
  {
    id: 8,
    name: "PortFolio",
    category: ["creative", "design"],
    image: "images/portfolio/2.jpg",
    slug: "apple-usb",
  },
  {
    id: 9,
    name: "Portfolio",
    category: ["portfolio"],
    image: "images/portfolio/3.jpg",
    slug: "portfolio-space",
  },
];

function Portfolios() {
  const [getAllItems] = useState(allData);
  const [dataVisibleCount, setDataVisibleCount] = useState(6);
  const [dataIncrement] = useState(3);
  const [activeFilter, setActiveFilter] = useState("");
  const [visibleItems, setVisibleItems] = useState([]);
  const [noMorePost, setNoMorePost] = useState(false);

  useEffect(() => {
    setActiveFilter(filters[0].name.toLowerCase());
    setVisibleItems(getAllItems.filter((item) => item.id <= 6));
  }, [getAllItems]);

  const handleChange = (e) => {
    console.log(e.target.value);
    e.preventDefault();
    let targetFilter = e.target.value
      ? e.target.value.toLowerCase()
      : e.target.textContent.toLowerCase();
    setActiveFilter(targetFilter);
    let tempData;
    if (targetFilter === filters[0].name.toLowerCase()) {
      tempData = getAllItems.filter((data) => data.id <= dataVisibleCount);
    } else {
      tempData = getAllItems.filter((data) => {
        return (
          data.category.includes(targetFilter) && data.id <= dataVisibleCount
        );
      });
    }
    setVisibleItems(tempData);
  };

  const handleLoadmore = (e) => {
    e.preventDefault();
    let tempCount = dataVisibleCount + dataIncrement;

    if (tempCount > getAllItems.length) {
      setNoMorePost(true);
    } else {
      setDataVisibleCount(tempCount);
      if (activeFilter === filters[0].name.toLowerCase()) {
        setVisibleItems(getAllItems.filter((data) => data.id <= tempCount));
      } else {
        let items = getAllItems.filter((data) => {
          return data.category.includes(activeFilter) && data.id <= tempCount;
        });
        setVisibleItems(items);
      }
    }
  };

  return (
    // <>
    //   <ul className="portfolio-filter list-inline">
    //     {filters.map((filter) => (
    //       <li
    //         className={
    //           filter.name.toLowerCase() === activeFilter
    //             ? "list-inline-item current"
    //             : "list-inline-item"
    //         }
    //         key={filter.id}
    //         onClick={handleChange}
    //       >
    //         {filter.name}
    //       </li>
    //     ))}
    //   </ul>

    //   <div className="pf-filter-wrapper mb-4">
    //     <select
    //       className="portfolio-filter-mobile"
    //       onChange={(e) => handleChange(e)}
    //     >
    //       {filters.map((filter) => (
    //         <option value={filter.name} key={filter.id}>
    //           {filter.name}
    //         </option>
    //       ))}
    //     </select>
    //   </div>

    //   <div className="row portfolio-wrapper">
    //     {visibleItems.map((item) => (
    //       <div className="col-md-4 col-sm-6 grid-item" key={item.id}>
    //         <Portfolio portfolio={item} />
    //       </div>
    //     ))}
    //   </div>

    //   {noMorePost ? null : (
    //     <div className="load-more text-center mt-4">
    //       <a
    //         href="#!"
    //         className="btn btn-default"
    //         onClick={(e) => handleLoadmore(e)}
    //       >
    //         <i className="fas fa-circle-notch"></i> Load more
    //       </a>
    //     </div>
    //   )}
    // </>
    <>
      <ul className="portfolio-filter list-inline">
        {filters.map((filter) => (
          <li
            className={
              filter.name.toLowerCase() === activeFilter
                ? "list-inline-item current"
                : "list-inline-item"
            }
            key={filter.id}
            onClick={handleChange}
          >
            {filter.name}
          </li>
        ))}
      </ul>

      <div className="pf-filter-wrapper mb-4">
        <select
          className="portfolio-filter-mobile"
          onChange={(e) => handleChange(e)}
        >
          {filters.map((filter) => (
            <option value={filter.name} key={filter.id}>
              {filter.name}
            </option>
          ))}
        </select>
      </div>

      <div className="row portfolio-wrapper">
        {visibleItems.map((item) => (
          <div className="col-md-4 col-sm-6 grid-item" key={item.id}>
            <Portfolio portfolio={item} />
          </div>
        ))}
      </div>

      {noMorePost ? null : (
        <div className="load-more text-center mt-4">
          <a
            href="#!"
            className="btn btn-default"
            onClick={(e) => handleLoadmore(e)}
          >
            <i className="fas fa-circle-notch"></i> Load more
          </a>
        </div>
      )}
    </>
  );
}

export default Portfolios;
